import { Tag, Flex, Collapse } from "antd"
let colors = ["magenta", "red", "volcano", "orange", "gold", "lime", "green", "cyan", "blue", "geekblue", "purple"]

export default function Tags(props) {


    let getTags = () => {
        let tags = []
        if (props.tags && props.tags != 0) {
            for (let key in props.tags) {
                if (props.tags[key] && props.tags[key].length != 0) {
                    for (let k of props.tags[key]) {
                        if (props.values && props.values[k] != null) {
                            k = props.values[k]
                        }

                        tags.push(
                            <Tag
                                key={k}
                                color={colors[Math.floor(Math.random() * colors.length)]}>{key}:{
                                    k
                                }
                            </Tag>
                        )

                    }
                }
            }
        }
        return tags
    }
    const renderTags = () => {
        let l = null
        if (props.tags && props.tags != 0) {
            l = <Collapse
                size="small"
                items={[
                    {
                        key: '1',
                        label: "Filters",
                        children: <p>{getTags()}</p>
                    }
                ]}
            />

        }
        return l
    };

    return <Flex wrap="wrap" style={{ paddingTop: '15px' }}>
        {renderTags()}
    </Flex>
}